import { CXPodOnboardingSchema } from "../schemas/CXEntities";

export default {
  ...CXPodOnboardingSchema,
  transform: (n, write = false) => {
    return { ...n };
  },
};
